<div class="custom-date-picker" [class.disabled]="disabled" clickOutside (clickOutside)="closeCalendar()">
  <!-- Input Field -->
  <div class="date-input-container" (click)="toggleCalendar()">
    <input 
      type="text" 
      class="date-input" 
      [placeholder]="placeholder"
      [value]="inputValue"
      [disabled]="disabled"
      (keydown)="filterNonNumeric($event)"
      (input)="handleManualInput($event)"
      (blur)="commitManualInput()"
    />
    <div class="calendar-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <!-- Year Picker Dropdown -->
  <div class="calendar-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <!-- Year Header -->
    <div class="year-header">
      <div class="year-range">
        {{ yearRange[0] }} - {{ yearRange[yearRange.length - 1] }}
        <div class="up-arrow">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="navigation-arrows">
        <button class="nav-arrow" (click)="previousYearRange()" type="button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-arrow" (click)="nextYearRange()" type="button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Year Grid -->
    <div class="year-grid">
      <div 
        class="year-item" 
        *ngFor="let year of yearRange"
        [class.selected]="year === selectedYear"
        [class.disabled]="isDisabled(year)"
        (click)="!isDisabled(year) && selectYear(year)"
      >
        {{ year }}
      </div>
    </div>
  </div>
</div>